// extracted by mini-css-extract-plugin
module.exports = {"fallbackContainer":"Fallback_fallbackContainer__wOZQq","fadeout":"Fallback_fadeout__3cQZ5","fallbackContainerImage":"Fallback_fallbackContainerImage__3px4S"};